<div class="text-right" *ngIf="!disableImageSelector" appendTo="body">
  <button pButton type="button" class="btn btn-default" *ngIf="!showImageSelector" (click)="toggleShowImageSelector()">
    {{ 'shared.widgets.wysiwyg-editor.image-selector-button-text' | translate | titlecase }}
  </button>
</div>
<div class="row">
  <div class="col-sm-6">
    <div *ngIf="showHtmlTemplates">
      <select class="form-control" [(ngModel)]="selectedHtmlTemplate" (ngModelChange)="handleHtmlTemplateChange($event)">
        <option *ngFor="let htmlTemplate of htmlTemplates" [value]="htmlTemplate.HTML">
          {{ htmlTemplate.Title }}
        </option>
      </select>
    </div>
  </div>
  <div class="col-sm-6" *ngIf="!disableImageSelector">
    <div *ngIf="showImageSelector">
      <wl-image-lookup #imageLookup (onImageChanged)="imageChanged($event)"></wl-image-lookup>
    </div>
  </div>
</div>
<div class="mct-flex mct-row w-100">
  <div style="min-width: 0; width: 100%">
    <div #editorHost class="wl-ckeditor-host" [id]="editorName"></div>
  </div>
</div>
